import { taggedSum } from 'daggy'

export const Maybe = taggedSum('Maybe', {
  JUST: ['value'],
  NOTHING: [],
})
